export const ACCESS_TOKEN = 'rec_access_token';
export const REFRESH_TOKEN = 'realestate_refresh_token';
export const REMEMBER_ME = 'remember_me';
export const USER_ACCOUNT_ID = 'user_account_id';
export const FCM_TOKEN = 'fcm_token';
export const PUBLIC_TOKEN = 'public_token';
